module.exports = __webpack_public_path__ + "img/c1.1b7b2f2e.png";